import React, { useEffect, useState } from "react";
import './PortfolioSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * PortfolioSection - Sección para mostrar trabajos con embeds de Spotify/YouTube
 * Soporta embeds de diferentes plataformas
 */
const PortfolioSection = ({ title, subtitle, projects = [], theme = 'dark', backgroundDecoration }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (projects.length === 0) {
      setCurrentIndex(0);
      return;
    }

    if (currentIndex >= projects.length) {
      setCurrentIndex(0);
    }
  }, [projects, currentIndex]);

  const goToNext = () => {
    if (projects.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  const goToPrev = () => {
    if (projects.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex - 1 + projects.length) % projects.length);
  };

  /**
   * Renderiza el embed según el tipo de plataforma
   */
  const renderEmbed = (project, index) => {
    const { type, embedUrl, title: projectTitle, artist, description } = project;

    return (
      <div className="portfolioItem" key={index}>
        <div className="embedContainer">
          {type === 'spotify' && (
            <iframe
              src={embedUrl}
              width="100%"
              height="352"
              frameBorder="0"
              allowFullScreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              title={projectTitle}
            ></iframe>
          )}

          {type === 'youtube' && (
            <iframe
              width="100%"
              height="315"
              src={embedUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={projectTitle}
            ></iframe>
          )}
        </div>

        {/* Información del proyecto */}
        <div className="projectInfo">
          <h3 className="projectTitle">{projectTitle}</h3>
          {artist && <p className="projectArtist">{artist}</p>}
          {description && <p className="projectDescription">{description}</p>}
        </div>
      </div>
    );
  };

  return (
    <div className={`portfolioContainer portfolioContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      {title && <h2 className="portfolioTitle">{title.toUpperCase()}</h2>}
      {subtitle && <p className="portfolioSubtitle">{subtitle}</p>}

      {projects.length > 0 && (
        <>
          <div className="portfolioCarousel">
            <button
              className="carouselButton"
              type="button"
              onClick={goToPrev}
              aria-label="Proyecto anterior"
            >
              ‹
            </button>

            <div className="portfolioViewport">
              {renderEmbed(projects[currentIndex], currentIndex)}
            </div>

            <button
              className="carouselButton"
              type="button"
              onClick={goToNext}
              aria-label="Siguiente proyecto"
            >
              ›
            </button>
          </div>

          <div className="carouselIndicators" aria-label="Indicadores de proyectos">
            {projects.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`indicatorDot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Ir al proyecto ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default PortfolioSection;
